// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/20250729051354/css/" + chunkId + "." + {"60":"1ae1851a","247":"e1a1a96e","334":"1ae1851a","430":"1ae1851a","446":"1ae1851a","561":"5e4ffd63","589":"3cfecafc","601":"cbc6a313","712":"988013af","910":"1ae1851a","940":"6cb59517","961":"e36e8a93"}[chunkId] + ".chunk.css";
};